// The file contents for the current environment will overwrite these during build.
// The build system defaults to the dev environment which uses `environment.ts`, but if you do
// `ng build --env=prod` then `environment.prod.ts` will be used instead.
// The list of which env maps to which file can be found in `.angular-cli.json`.

export const environment = {
  production: true,
  apiKey: 'ff744e09-9d5e-11e6-8145-0800274f2cef',
  apiRoot: 'https://apistaff.dreamjobs.com.co/v1',
  landing: 'https://user.dreamjobs.com.co/job/',
  apiGoogleKey: 'AIzaSyDiDWCREgYDr71JzCDISN5-CRC8LleVS1M',
  companyUrl: 'https://company.dreamjobs.com.co'  
};




// WEBPACK FOOTER //
// /Users/everis/code/Dj/front.staff/src/environments/environment.ts